<!-- #region FIXED TOGGLE -->
@if (!navService.isMobile()) {
    <button 
        class="d-flex align-items-center justify-content-center mt-2 fixed-toggle-btn no-print"
        (click)="navService.toggleNavFixed()" 
    >
        @if (navService.isNavFixed()) {
            <fa-icon 
                [icon]="faIconName.faArrowLeft" 
                class="fa-lg"
            ></fa-icon>
        } @else {
            <fa-icon 
                [icon]="faIconName.faArrowRight" 
                class="fa-lg"
            ></fa-icon>
        }
    </button>
}
<!-- #endregion -->

<!-- #region Nav Logo -->
<div class="nav-header no-print no-pointer">
	<div class="nav-image-ctnr">
		<img 
            [src]="fileLogoUrl" 
            height="35px" 
            width="35px"
            alt=""
        />
	</div>
    @if (!isProduction) { <div class="beta-text"></div> }
</div>
<!-- #endregion -->

<mat-nav-list class="no-print">
    <!--
        S2N-3075: a possession-enabled Witness has a real dashboard - the possession experience -
        and so gets Home too. witnessHasCustody is false for every other profile and for a base
        Witness, whose dashboard redirects to their account page.
        S2N-3076: the dashboard is View Only's landing page too, so Home shows for an agency reader.
    -->
    @if (
        isOperational
        || canReadAgency
        || witnessHasCustody
    ) {
        <mat-list-item 
            [class.active-nav-parent-item]="navService.selectedMainNav() === 'Home'"
            (click)="navService.homeButtonClick()" 
            class="px-2" 
        >
            <span class="d-flex flex-row">
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="faIconName.faHouse" 
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
                <span class="mr-auto">Home</span>
            </span>
        </mat-list-item>
    }

    @if (!isApiUser) {
        <!-- Nav routes from getMainNavRoutes() in nav.service.ts -->
        @for (nav of navService.navRoutes(); track nav) {
            @if (!nav?.isSubNav) { 
                @if (nav?.isInventory) { <ng-container *ngTemplateOutlet='inventoryList; context: { nav: nav, level: 0 }' /> } 
                @else if (nav?.name != "") { <ng-container *ngTemplateOutlet='navItem; context: { nav: nav, level: 0 }' /> }
            }
        }
        <!-- #region SEARCH CONTROL VALUES -->
        @if (
            user?.controlValues 
            && !isWitness
        ) {
            <mat-list-item 
                class="px-2"  
                (click)="redirect('/reports/control-value')" 
                [ngClass]="{'active-nav-parent-item': searchCvSelected}"
            >
                <span class="d-flex flex-row">
                    <div class="parent-nav-icon-container">
                        <fa-icon 
                            [icon]="faIconName.faBarcodeRead" 
                            class="parent-nav-icon"
                        ></fa-icon>
                    </div>
                    <span class="mr-auto">Search Control Values</span>
                </span>
            </mat-list-item>
        }
        <!-- #endregion -->
    } @else {
        <!-- Integration partners' own Details. Their API Settings are under Admin > Developer. -->
        <mat-list-item
            class="px-2"
            (click)="redirect('/company/info/' + user.clientId)"
            [class.active-nav-parent-item]="navService.selectedMainNav() === 'company'"
        >
            <span class="d-flex flex-row">
                <div class="parent-nav-icon-container">
                    <fa-icon
                        [icon]="faIconName.faGear"
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
                <span class="mr-auto">Settings</span>
            </span>
        </mat-list-item>
        <!-- getMainNavRoutes() gives API users only Admin > Developer. -->
        @for (nav of navService.navRoutes(); track nav) {
            @if (
                !nav?.isSubNav
                && nav?.name != ""
            ) { <ng-container *ngTemplateOutlet='navItem; context: { nav: nav, level: 0 }' /> }
        }
    }
    <hr />

    <!-- #region USER PROFILE -->
	<mat-list-item 
        [class.active-nav-parent-item]="navService.selectedMainNav() === 'profile'"
        (click)="toggleUserProfileSubNav()" 
        class="px-2" 
    >
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon 
                    [icon]="faIconName.faUser" 
                    class="parent-nav-icon"
                ></fa-icon>
            </div>
            <span class="mr-auto">{{ user?.fullName }}</span>
            <fa-icon 
                [icon]="faIconName.faAngleDown" 
                [class.rotate]="navService.userProfileExpanded()"
                class="dropdown-icon"
            ></fa-icon>	
        </span>
    </mat-list-item>
    @if (navService.userProfileExpanded()) {
        <div class="submenu expanded">
            <a 
                mat-list-item 
                [routerLink]="(isWitness ? 'admin/users/edit/security/' : 'admin/users/edit/details/') + user?.id"
                class='px-2'
                (click)="navLinkClicked(nav, level)"
            ><span class='ml-4'>My Profile</span></a>
            <mat-button-toggle-group 
                aria-label="Theme Toggle"
                [value]="themeOption"
                (change)="toggleTheme($event)"
                class="ml-1-point-2 d-flex custom-theme-toggle"
            >
                @for (theme of themes; track theme;) {
                    <mat-button-toggle 
                        [value]="theme" 
                        class="custom-theme-toggle"
                    >
                        @if (theme == "Light") {
                            <fa-icon 
                                [icon]="faIconName.faSun" 
                                class="parent-nav-icon" 
                                matTooltip="Light Theme"
                                matTooltipPosition="above"
                            ></fa-icon>	
                        } @else if (theme == "Dark") { 
                            <fa-icon 
                                [icon]="faIconName.faMoon" 
                                class="parent-nav-icon" 
                                matTooltip="Dark Theme"
                                matTooltipPosition="above"
                            ></fa-icon>	
                        } 
                    </mat-button-toggle>
                }
            </mat-button-toggle-group>
            <!-- Logout -->
            <mat-list-item 
                (click)="logout()" 
                class='px-2'
            >
                <span class='ml-4'>Logout</span>
            </mat-list-item>
        </div>
    }
    <!-- #endregion -->

    <!-- #region HELP -->
    @if (!isApiUser) {
        <mat-list-item 
            (click)="openKnowledgeBase()"
            class="px-2"
        >
            <span class="d-flex flex-row">
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="faIconName.faQuestionCircle" 
                        class="parent-nav-icon"
                    ></fa-icon>                    
                </div>
                <span class="mr-auto">Help</span>
            </span>
        </mat-list-item>        
    }    
    <!-- #endregion -->
    <hr />

    <!-- #region Show Current Customer -->
    <mat-list-item class="px-2 no-hover customer-container">
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon 
                    [icon]="faIconName.faStaffSnake" 
                    class="parent-nav-icon"
                ></fa-icon>
            </div>
            <span class="customer-name mr-auto">{{ clientName }}</span>
        </span>
	</mat-list-item>
    <!-- #endregion -->

    <!-- #region Change Customer -->
    @if (
        isSysAdmin 
        || showSwapClient
     ) {
        <mat-list-item 
            (click)="openChangeClientModal();"
            class="px-2 customer-container" 
        >
            <span class="d-flex flex-row">
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="faIconName.faSwap" 
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
                <span class="customer-name">Change Agency</span>
                <fa-icon 
                    [icon]="faIconName.faAngleDown" 
                    class="dropdown-icon ml-auto" 
                ></fa-icon>	
            </span>
        </mat-list-item>
     }
    <!-- #endregion -->

    <!-- Anchor element used to check for any off screen nav items -->
    <a id='navAnchor'>&nbsp;</a>
</mat-nav-list>

<ng-template 
    #navItem 
    let-nav='nav' 
    let-level='level'
>
    @if (navService.canViewNav(nav)) {
        <ng-container
            *ngTemplateOutlet="nav?.children?.length ? navItemTree : navItemNode; 
            context: { nav: nav, level: level }" 
        />
    }
</ng-template>

<!-- This is an Angular template for a navigation item in a side navigation menu with child records. -->
<ng-template 
    #navItemTree 
    let-nav='nav' 
    let-level='level'
>
    <mat-list-item 
        [class.active-nav-parent-item]="nav?.name === navService.selectedMainNav()"
        (click)="navService.toggleSubNav(nav)" 
        class='px-2 pointer'
    >
        <span 
            class="d-flex flex-row" 
            [class.ml-4]='level > 0'
        >
            @if (nav?.icon) {
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="nav?.icon" 
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
            }
            @if (nav?.name?.length < 17) { <a><span>{{ nav?.shortName ?? nav?.name }}</span></a> }
            @else { <a><span>{{ nav?.shortName ?? nav?.name.slice(0, 17) }}...</span></a> }
            <fa-icon 
                [icon]="faIconName.faAngleDown" 
                [class.rotate]="nav.expanded" 
                class="dropdown-icon ml-auto"
            ></fa-icon>
        </span>
    </mat-list-item>
    @if (nav.expanded) {
        <div class="submenu expanded">
            @for (subNav of nav?.children; track subNav) {
                <ng-container *ngTemplateOutlet='navItem; context: { nav: subNav, level: level + 1 }' />
            }
        </div>
    }
</ng-template>

<!-- 
    This is an Angular template for an end navigation item in a side navigation menu. 
    It displays a list item with an icon, label, and optional loading spinner. 
    The list item is clickable and can navigate to a specific route or URL. 
    The `navLinkClicked` function is called when the list item is clicked, passing the name and level of the navigation item. 
    The `navLinkIsLoading` function is used to determine whether to display a loading spinner. 
-->
<ng-template 
    #navItemNode 
    let-nav='nav' 
    let-level='level'
>
    <a 
        mat-list-item  
        (click)='navLinkClicked(nav?.name, level, nav?.openNewTab, nav?.path)'
        [class.active-nav-parent-item]="nav?.name === navService.selectedMainNav()"
        [disabled]="navLinkIsLoading(nav?.name, level)"
        [routerLink]="!nav?.href?.length ? nav?.path : nav?.href"
        [state]="{ pcgUserNav: true }"
        class='px-2 pointer'
    >
        <span 
            class="d-flex flex-row" 
            [class.ml-4]='level > 0'
        >
            @if (nav?.icon) {
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="nav?.icon" 
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
            }
            @if (nav?.name?.length < 17) { <span>{{ nav?.shortName ?? nav?.name }}</span> }
            @else { 
                <span 
                    container="body" 
                    [ngbTooltip]="nav?.name" 
                    placement="left"
                >
                    {{ nav?.shortName ?? nav?.name.slice(0, 17) }}...
                </span>
            }
            @if (navLinkIsLoading(nav?.name, level)) {
                <span 
                    class="spinner-border spinner-border-sm align-middle ml-2 my-1" 
                    output="status" 
                    aria-hidden="true"
                ></span>
            }
        </span>
    </a>
</ng-template>

<ng-template
    #inventoryList
    let-nav='nav'
    let-level='level'
>
    <!--
        S2N-1420: these per-inventory links are written out by hand instead of coming from the
        secured nav routes, so several carried no permission test at all (Transaction History) or
        tested the wrong thing ("not a Provider", which a Witness also satisfies — Transfers).
        Each link now states the capability the server enforces behind it: `isOperational`
        (CoreFeatures) for the operational screens, `canViewAssociatedInventories`
        (AssociatedInventoryView) for the two read-only screens a Witness is entitled to.
        S2N-3076: `canReadAgency` (AgencyRead) joins every LIST link — View Only sees the lists an
        Admin sees — and none of the create/"new" actions (First Time Setup).
    -->
    @if (
        isOperational 
        || canViewAssociatedInventories
        || canReadAgency
    ) {
        <mat-list-item
            [class.active-nav-parent-item]="navService.selectedMainNav() === 'inventory'"
            (click)="toggleInventoriesSubNav();"
            [disabled]="navLinkIsLoading(nav?.name, level)"
            class="px-2 pointer"
        >
            <span 
                class="d-flex flex-row" 
                [class.ml-4]='level > 0'
            >
                <div class="parent-nav-icon-container">
                    <fa-icon 
                        [icon]="faIconName.faShelves" 
                        class="parent-nav-icon"
                    ></fa-icon>
                </div>
                <span>Inventories</span>
                <fa-icon 
                    [icon]="faIconName.faAngleDown" 
                    [class.rotate]="navService.inventoriesExpanded()"
                    class="dropdown-icon ml-auto"
                ></fa-icon>	
            </span>
        </mat-list-item>
        @if (navService.inventoriesExpanded()) {
            <div class="submenu expanded">
                @if (isOperational || canReadAgency || isRestrictedReader) {
                    <a
                        mat-list-item
                        [routerLink]="'/inventory/list'"
                        class="pointer"
                    ><span>Dashboard</span></a>
                }
                @for (inventory of gvs.inventories(); track inventory; let i = $index) {
                    <mat-list-item 
                        (click)="toggleInventorySubNav(inventory?.name)"
                        class="parent pointer"
                    >
                        @if (inventory?.name?.length < 17) { <span>{{ inventory?.name }}</span> }
                        @else { <span>{{ inventory?.name.slice(0, 17) }}...</span> }
                        <fa-icon 
                            [icon]="faIconName.faAngleDown" 
                            [ngClass]="{'rotate': gvs.userInvMenu()[i]?.value}" 
                            class="dropdown-icon ml-auto"
                        ></fa-icon>
                    </mat-list-item>
                    @if (gvs.userInvMenu()[i]?.value) {
                        <div 
                            class="submenu"
                            [ngClass]="{'expanded': gvs.userInvMenu()[i]?.value}"
                        >
                            @if (inventory.isFirstTimeSetup) {
                                @if (isOperational) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/product-setup/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>First Time Setup</span></a>
                                }
                            } @else {
                                <!-- Products and Med Use are the screens AssociatedInventoryView opens. -->
                                @if (isOperational || canReadAgency || isRestrictedReader) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/products/list/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Products</span></a>
                                }
                                <!--
                                    S2N-3075: a possession-enabled Witness opens this list too - it
                                    is where they see the custody work they have in flight and start
                                    a new one. The server narrows it to the events they STARTED, so
                                    it is their own custody records rather than the inventory's
                                    history. witnessHasCustody is false for every other profile and
                                    for a base Witness.
                                    S2N-3076: an agency reader opens the whole list, read-only.
                                -->
                                @if (
                                    isOperational
                                    || canReadAgency
                                    || witnessHasCustody
                                ) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/shift-change/list/' + inventory.id"
                                        [state]="{ pcgUserNav: true }"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>{{ gvs.clientShiftChangeName() }}</span></a>
                                }
                                @if (inventory.inventoryType != 4) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/inv-actions/list/' + inventory.id"
                                        [state]="{ pcgUserNav: true }"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>{{ gvs.clientMedUseName() }}</span></a>
                                }
                                <!--
                                    S2N-3076: positive form of "locked for techs" — locked hides Transfers from a Provider only;
                                    Manager and above, and an agency reader, still see the list.
                                    S2N-1420 (Phase 6): a Witness (isRestrictedReader) reads transfers, and signs as
                                    their witness, whatever the lock says — the lock only ever applied to Providers.
                                -->
                                @if (
                                    (
                                        (isOperational || canReadAgency)
                                        && (
                                            !isTransferLockedForTechs
                                            || isManager
                                            || isAdmin
                                            || isSysAdmin
                                            || canReadAgency
                                        )
                                    )
                                    || isRestrictedReader
                                ) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/transfers/list/' + inventory.id"
                                        [state]="{ pcgUserNav: true }"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Transfers</span></a>
                                }
                                @if (
                                    isManager
                                    || isAdmin
                                    || isSysAdmin
                                    || canReadAgency
                                    || isRestrictedReader
                                ) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/reconciliation/list/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Reconciliation</span></a>
                                }
                                <!--
                                    The truck-replenishment branch below is the one with no profile
                                    test of its own, so it leans entirely on isOperational (or, for
                                    an agency reader, canReadAgency; for a Witness, isRestrictedReader).
                                -->
                                @if (
                                    (isOperational || canReadAgency || isRestrictedReader)
                                    && (
                                        (
                                            inventory.inventoryType === 1
                                            && (
                                                isManager
                                                || isAdmin
                                                || isSysAdmin
                                                || canReadAgency
                                                || isRestrictedReader
                                            )
                                        ) || (
                                            inventory.inventoryType === 0
                                            && gvs.isUsingTruckReplenishment()
                                        ) || (
                                            inventory.inventoryType === 4
                                            && (
                                                isManager
                                                || isAdmin
                                                || isSysAdmin
                                                || canReadAgency
                                                || isRestrictedReader
                                            )
                                        )
                                    )
                                ) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/replenishment/list/' + inventory.id"
                                        [state]="{ pcgUserNav: true }"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    >
                                        <span>
                                            {{ 
                                                inventory.inventoryType === 1 || inventory.inventoryType === 4 
                                                    ? 'Replenishment' 
                                                    : gvs.clientTruckReplenishmentName()
                                            }}
                                        </span>
                                    </a>
                                }
                                @if (
                                    inventory.inventoryType === 3
                                    && (
                                        isManager
                                        || isAdmin
                                        || isSysAdmin
                                        || canReadAgency
                                        || isRestrictedReader
                                    )
                                ) {
                                    <a 
                                        mat-list-item 
                                        [routerLink]="'/inventory/dea-forms/list/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>DEA Form 41</span></a>
                                }
                                @if (
                                    inventory.inventoryType === 2
                                    && (
                                        isManager
                                        || isAdmin
                                        || isSysAdmin
                                        || canReadAgency
                                        || isRestrictedReader
                                    )
                                ) {
                                    <a 
                                        mat-list-item 
                                        [routerLink]="'/inventory/return-logs/list/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Return Logs</span></a>
                                }
                                @if (isOperational || canReadAgency) {
                                    <a
                                        mat-list-item
                                        [routerLink]="'/inventory/transaction-history/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Transaction History</span></a>
                                }
                                @if (
                                    isManager 
                                    || isAdmin 
                                    || isSysAdmin
                                    || canReadAgency
                                ) {
                                    <a 
                                        mat-list-item 
                                        [routerLink]="'/inventory/timeline/' + inventory.id"
                                        class="pointer"
                                        (click)="navLinkClicked(nav, level)"
                                    ><span>Timeline</span></a>
                                }
                            }
                        </div>
                    }
                }
            </div>
        }
    }
</ng-template>

@if (navContentOffscreen()) {
    <div 
        class='bg-secondary rounded px-3 text-center cursor-pointer scroll-down-position' 
        (click)="scrollToBottom()"
    >
        <fa-icon 
            [icon]="faIconName.faAngleDown" 
            class="text-white"
        ></fa-icon>
    </div>
}

<ng-template 
    #modalChangeClient 
    let-modal
>
    <div class="modal-header">
		<h5 
            class="modal-title" 
            id="modal-basic-title"
        >Change Agency</h5>
		<button 
			type="button" 
			class="close" 
			aria-label="Close" 
			(click)="modal.dismiss()"
		><span aria-hidden="true">&times;</span></button>
	</div>

    <div class="modal-body">
        <!-- S2N-3242: this reads like the dropdown it replaces, but the list is inline rather
             than a floating p-select panel. An overlay panel never took a touch drag on iOS, so
             the list was unreachable on a phone; inline content scrolls there like anything
             else in the dialog. -->
        <button
            type="button"
            class="agency-switch-trigger"
            [class.open]="agencyListOpen()"
            [attr.aria-expanded]="agencyListOpen()"
            aria-haspopup="listbox"
            (click)="toggleAgencyList()"
        >
            <span class="agency-switch-trigger-text">{{ selectedAgencyText() }}</span>
            <span class="agency-switch-caret" aria-hidden="true"></span>
        </button>

        @if (agencyListOpen()) {
            <input
                #agencySearch
                type="text"
                class="form-control agency-switch-search"
                placeholder="Search agencies..."
                aria-label="Search agencies"
                autocomplete="off"
                [ngModel]="agencyFilter()"
                (ngModelChange)="agencyFilter.set($event)"
                [ngModelOptions]="{ standalone: true }"
            />

            <ul class="agency-switch-list" role="listbox">
                @for (agency of filteredClientItems(); track agency.value) {
                    <li role="presentation">
                        <button
                            type="button"
                            role="option"
                            class="agency-switch-option"
                            [class.selected]="agency.value === currentClientId"
                            [attr.aria-selected]="agency.value === currentClientId"
                            (click)="selectAgency(agency.value)"
                        >{{ agency.text }}</button>
                    </li>
                } @empty {
                    <li class="agency-switch-empty">No agencies match that search.</li>
                }
            </ul>
        }
    </div>

    <div class="modal-footer">
		<button 
            type="button" 
            class="btn btn-cancel btn-lg" 
            (click)="modal.dismiss()"
        >Cancel</button>
		<button 
            type="button" 
            class="btn btn-save btn-lg" 
            (click)="saveChangeClient(modal)"
        >Change Agency</button>
	</div>
</ng-template>
